export default {"src":"/_next/static/media/steering-wheel.b9efe0c4.svg","height":60,"width":60};